// extracted by css-extract-rspack-plugin
export default {"countValue":"countValue-rWfP8r","moreApps":"moreApps-BQLJM8","footnote":"footnote-ZPkanq"};